import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'reactstrap';
import { FooterStyle } from './footerStyle.js';

/**
 * Renders a footer section with two buttons.
 * The buttons are conditionally rendered based on the value of the `isFormFilled` state variable.
 */
const Footer = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    const currentPath = window.location.pathname;
    const currentPageNumber = parseInt(currentPath.replace(/\D/g, ''));
    const nextStep = `/simulacao/${Math.min(currentPageNumber + 1, 10)}`;

    if (currentPageNumber === 3) {
      navigate('/simulacao/1');
    } else {
      navigate(-1);
    }
  };

  const handleContinueClick = () => {
    const currentPath = window.location.pathname;
    const currentPageNumber = parseInt(currentPath.replace(/\D/g, ''));
    const nextStep = `/simulacao/${Math.min(currentPageNumber + 1, 10)}`;

    navigate(nextStep);
  };

  return (
    <FooterStyle className="d-flex btn-group">
      <section className="btn-wrapper">
        <Button className="btn-custom-back" onClick={handleBack}>
          Voltar
        </Button>
        <Button className="btn-custom-principal" onClick={handleContinueClick}>
          Continuar
        </Button>
      </section>
    </FooterStyle>
  );
};

export default Footer;
